import { AnimatePresence, motion } from 'framer-motion'
import React, { forwardRef, useImperativeHandle, useRef } from 'react'
import styled from 'styled-components'
import { system } from 'styled-system'

import { FlowCanvas } from './FlowCanvas'

export const MasonryGrid = forwardRef(
  ({ imageData, stackedMetadata = false, ...props }, ref) => {
    const gridContainerRef = useRef()
    useImperativeHandle(ref, () => gridContainerRef.current)

    return (
      <MasonryGridContainer
        columnCount={[1, 1, 2, 3, 3]}
        columnGap={[0, 4]}
        {...props}
      >
        <AnimatePresence>
          {imageData.map(i => {
            const { href, image, author, title, key: imageKey, imageCount } = i
            return (
              <motion.div
                key={imageKey}
                initial={{ opacity: 0 }}
                animate={{
                  opacity: 1,
                  transition: { duration: 0.3, ease: 'easeOut' }
                }}
              >
                <FlowCanvas
                  href={href}
                  author={author}
                  image={image}
                  imageCount={imageCount}
                  title={title}
                  display="inline-flex"
                  mb={[42, 4]}
                  stackedMetadata={stackedMetadata}
                />
              </motion.div>
            )
          })}
        </AnimatePresence>
      </MasonryGridContainer>
    )
  }
)

const masonryGridSystem = system({
  columnCount: {
    property: 'columnCount'
  },
  columnGap: {
    property: 'columnGap',
    scale: 'space'
  }
})

const MasonryGridContainer = styled('div')(
  {
    width: '100%'
  },
  masonryGridSystem
)
